var _line, _path, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineOrLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 23,
    viewBox: "0 0 304 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 10.5996,
    x2: 136.5,
    y2: 10.5996,
    stroke: "#E8E8E8",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.335 16.2256C148.616 16.2256 147.963 16.0623 147.375 15.7356C146.796 15.4089 146.339 14.9469 146.003 14.3496C145.676 13.7429 145.513 13.0429 145.513 12.2496C145.513 11.4656 145.681 10.7749 146.017 10.1776C146.362 9.57094 146.829 9.10894 147.417 8.79161C148.005 8.46494 148.663 8.30161 149.391 8.30161C150.119 8.30161 150.777 8.46494 151.365 8.79161C151.953 9.10894 152.415 9.56628 152.751 10.1636C153.096 10.7609 153.269 11.4563 153.269 12.2496C153.269 13.0429 153.092 13.7429 152.737 14.3496C152.392 14.9469 151.92 15.4089 151.323 15.7356C150.726 16.0623 150.063 16.2256 149.335 16.2256ZM149.335 15.1056C149.792 15.1056 150.222 14.9983 150.623 14.7836C151.024 14.5689 151.346 14.2469 151.589 13.8176C151.841 13.3883 151.967 12.8656 151.967 12.2496C151.967 11.6336 151.846 11.1109 151.603 10.6816C151.36 10.2523 151.043 9.93494 150.651 9.72961C150.259 9.51494 149.834 9.40761 149.377 9.40761C148.91 9.40761 148.481 9.51494 148.089 9.72961C147.706 9.93494 147.398 10.2523 147.165 10.6816C146.932 11.1109 146.815 11.6336 146.815 12.2496C146.815 12.8749 146.927 13.4023 147.151 13.8316C147.384 14.2609 147.692 14.5829 148.075 14.7976C148.458 15.0029 148.878 15.1056 149.335 15.1056ZM156.218 9.67361C156.442 9.23494 156.76 8.89428 157.17 8.65161C157.59 8.40894 158.099 8.28761 158.696 8.28761V9.60361H158.36C156.932 9.60361 156.218 10.3783 156.218 11.9276V16.0996H154.944V8.42761H156.218V9.67361Z",
    fill: "#A2A2A2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    y1: 10.5996,
    x2: 304,
    y2: 10.5996,
    stroke: "#E8E8E8",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineOrLine);
export default __webpack_public_path__ + "static/media/line-or-line.4588b0bcdc5469d15366f66234e3db0c.svg";
export { ForwardRef as ReactComponent };